import React from "react";
import Navbar from "../components/common/navbar";
import Footer from "../components/common/footer";
import AllOrders from "../components/account/allOrders";
import MobileSidebarLink from "../components/account/mobileSidebarLink";

const AllOrderPage = () => {
  return (
    <div>
      <Navbar />
      <div className="md:mx-16 flex">
        <div className="hidden md:block">
        <MobileSidebarLink />
        </div>
        <AllOrders />
      </div>
      <Footer />
    </div>
  );
};

export default AllOrderPage;
